import { createSlice } from '@reduxjs/toolkit';
import { BibleQuote, Nullable } from '../../types';
import { Paginated } from '../../services/api-handlers/pagination';
import { takeOne } from '../../helpers/store';
import {
    createBibleQuote,
    deleteBibleQuote,
    getAllBibleQuotes,
    getBibleQuote,
    listBibleQuotes,
    updateBibleQuote,
} from '../thunks/bible-quote-thunks';
import { ReducerState } from '../configure-store';

export interface BibleQuoteState extends ReducerState {
    data: Paginated<BibleQuote>;
    current: Nullable<BibleQuote>;
}

const initialState: BibleQuoteState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

const slice = createSlice({
    name: 'bible-quote',
    initialState,
    reducers: {
        resetBibleQuoteCurrent: (state: BibleQuoteState) => {
            state.current = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(listBibleQuotes.pending, takeOne.pendingActionCase)
            .addCase(listBibleQuotes.rejected, takeOne.rejectedActionCase)
            .addCase(listBibleQuotes.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = action.payload;
            })

            .addCase(getAllBibleQuotes.pending, takeOne.pendingActionCase)
            .addCase(getAllBibleQuotes.rejected, takeOne.rejectedActionCase)
            .addCase(getAllBibleQuotes.fulfilled, takeOne.fulfilledActionCase)

            .addCase(getBibleQuote.pending, takeOne.pendingActionCase)
            .addCase(getBibleQuote.rejected, takeOne.rejectedActionCase)
            .addCase(getBibleQuote.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.current = action.payload;
            })

            .addCase(createBibleQuote.pending, takeOne.pendingActionCase)
            .addCase(createBibleQuote.fulfilled, takeOne.fulfilledActionCase)
            .addCase(createBibleQuote.rejected, takeOne.rejectedActionCase)

            .addCase(updateBibleQuote.pending, takeOne.pendingActionCase)
            .addCase(updateBibleQuote.fulfilled, takeOne.fulfilledActionCase)
            .addCase(updateBibleQuote.rejected, takeOne.rejectedActionCase)

            .addCase(deleteBibleQuote.pending, takeOne.pendingActionCase)
            .addCase(deleteBibleQuote.fulfilled, takeOne.fulfilledActionCase)
            .addCase(deleteBibleQuote.rejected, takeOne.rejectedActionCase);
    },
});

export const { resetBibleQuoteCurrent } = slice.actions;

export default slice.reducer;
